import React from 'react';
import { useAppContext } from 'src/components/app-context';
import { Behavior } from '@prisjakt/ui/text';
import { TitleSmallText } from '@prisjakt/ui/text/variants';
import { useOfferListFilterContext } from 'src/areas/product/components/offer-list-filter-context';
import { getFractalRepresentation, getSizeTitle } from './utils';
import { FilterType } from 'src/components/price-list/types';
import { DropdownButtonText, SelectionHighlightedText } from '../styles';

export const SizeVariantsButtonLabel = () => {
  const { t } = useAppContext();
  const { getFilter } = useOfferListFilterContext();
  const title = getSizeTitle(t);
  const variantSizeFilter = getFilter(FilterType.VARIANT_SIZE);
  const selectedSizeVariants = variantSizeFilter?.active
    ? variantSizeFilter?.selection
    : null;
  const selectedVariants =
    (selectedSizeVariants?.length &&
      selectedSizeVariants
        .sort()
        .map(x => getFractalRepresentation(x))
        .join(', ')) ??
    t('product', 'variants.all');

  return (
    <DropdownButtonText behavior={Behavior.OnelineEllipsis}>
      <TitleSmallText>
        {title}:{' '}
        <SelectionHighlightedText>{selectedVariants}</SelectionHighlightedText>
      </TitleSmallText>
    </DropdownButtonText>
  );
};
